import { useCallback, useState } from 'react';
import { SetAdminChangelogItemStatusAPI } from '../../../../api/AdminAPI';

const DONE_MESSAGE = {
  published: 'publicada(s)',
  draft: 'de volta a rascunho',
  reviewed: 'marcada(s) como revisada(s)',
  internal: 'marcada(s) como interna(s)',
  discarded: 'descartada(s)',
};

/**
 * useItemStatusChange
 *
 * Muda o status de várias novidades (item_status.php) e guarda as que a API bloqueou
 * (aguardando deploy, sem título, resumo ou área) para mostrar na tela.
 *
 * @param {{ notify: Function, onDone: Function }} options
 */
function useItemStatusChange({ notify, onDone }) {
  const [isChanging, setIsChanging] = useState(false);
  // [{ id, reason, title? }]
  const [blocked, setBlocked] = useState([]);

  /**
   * @param {Array<Object>} items - itens selecionados (para o título dos bloqueados)
   * @param {'draft'|'reviewed'|'published'|'internal'|'discarded'} status
   * @param {boolean} notifyBell - só vale ao publicar
   */
  const changeStatus = useCallback((items, status, notifyBell = false) => {
    if (items.length === 0) return;
    setIsChanging(true);
    setBlocked([]);
    const body = { ids: items.map((item) => item.id), status, notify_bell: status === 'published' && Boolean(notifyBell) };
    SetAdminChangelogItemStatusAPI(body, (response) => {
      setIsChanging(false);
      if (!response || response.success === false) {
        notify(response?.error || 'Não foi possível mudar o status.', 'error');
        return;
      }
      const titles = new Map(items.map((item) => [item.id, item.title || item.slug]));
      const blockedList = (Array.isArray(response.blocked) ? response.blocked : [])
        .map((entry) => ({ ...entry, title: titles.get(entry.id) || `Novidade ${entry.id}` }));
      setBlocked(blockedList);
      const changed = response.changed || 0;
      notify(
        `${changed} novidade(s) ${DONE_MESSAGE[status]}${blockedList.length ? `; ${blockedList.length} não puderam mudar` : ''}.`,
        blockedList.length ? 'warning' : 'success',
      );
      if (onDone) onDone();
    });
  }, [notify, onDone]);

  return { changeStatus, isChanging, blocked, clearBlocked: () => setBlocked([]) };
}

export default useItemStatusChange;
